/**
 * Service pour la gestion des élections
 * Version 3.5.3: Elections Management
 */

import api from './api.js';

/**
 * Obtenir toutes les élections
 */
export async function getAllElections() {
  const response = await api.get('/admin/elections');
  return response.data;
}

/**
 * Obtenir la prochaine élection à venir (endpoint public /elections/active)
 */
export async function getActiveElection() {
  const response = await api.get('/elections/active');
  return response.data;
}

/**
 * Élections de la campagne courante (active=true, date future ou non fixée)
 */
export async function getCampaignElections() {
  const response = await api.get('/elections/campaign');
  return response.data;
}

/**
 * Créer une nouvelle élection
 */
export async function createElection(electionData) {
  const response = await api.post('/admin/elections', electionData);
  return response.data;
}

/**
 * Mettre à jour une élection
 */
export async function updateElection(electionId, updates) {
  const response = await api.put(`/admin/elections/${electionId}`, updates);
  return response.data;
}

/**
 * Activer une élection
 */
export async function activateElection(electionId) {
  const response = await api.post(`/admin/elections/${electionId}/activate`);
  return response.data;
}

/**
 * Désactiver une élection
 */
export async function deactivateElection(electionId) {
  const response = await api.post(`/admin/elections/${electionId}/deactivate`);
  return response.data;
}

/**
 * Supprimer une élection
 */
export async function deleteElection(electionId) {
  const response = await api.delete(`/admin/elections/${electionId}`);
  return response.data;
}

/**
 * Vérifier l'éligibilité au vote pour un scrutin donné.
 *
 * `electionId` est omissible seulement quand la campagne n'a qu'un scrutin (D4) ;
 * avec plusieurs, le serveur répond `ELECTION_REQUIRED` — il ne choisit jamais.
 *
 * @param {string} dateNaissance
 * @param {string|null} electionId
 */
export async function checkEligibility(dateNaissance, electionId = null) {
  const response = await api.post('/elections/check-eligibility', {
    date_naissance: dateNaissance,
    election_id: electionId,
  });
  return response.data;
}
